import React from 'react';

// import routes
import {ROUTES, EXTERNAL_LINKS} from './routes';

// ***
// icons as React components
import { 
  FaFileDownload, 
  FaChalkboardTeacher,
} from "react-icons/fa";

// ***
// menu data
// simplified version
// currently in production use
// rendering method will automatically detect whether its a route or a external link
// @param {array | null} list - for side menu rendering
// @param {array | null} content - for dashboard rendering
export const sideMenuItems = [
  {
    key: "home", 
    value: ROUTES.HOME, 
    label: "iMetaLab Data Processing", 
    icon: "appstore", //antd icon
    list: null,
    content: [
      {
        key: "create-session", 
        value: `${ROUTES.DATAPROCESSING}${ROUTES.CREATESESSION}`, 
        label: "Create Session",
        icon: <FaChalkboardTeacher />, // font awesome icon
        list: null
      },
      {
        key: "track-session", 
        value: `${ROUTES.DATAPROCESSING}${ROUTES.TRACKSESSION}`, 
        label: "Track Session",
        icon: <FaFileDownload />, // font awesome icon
        list: null
      },
    ]
  },
  {
    key: "create-session", 
    value: `${ROUTES.DATAPROCESSING}${ROUTES.CREATESESSION}`, 
    label: "Create Data Processing Session",
    icon: <FaChalkboardTeacher />, // font awesome icon
    list: null,
    content: null,
  },
  {
    key: "track-session", 
    value: `${ROUTES.DATAPROCESSING}${ROUTES.TRACKSESSION}`, 
    label: "Track Data Processing Session",
    icon: <FaFileDownload />, // font awesome icon
    list: null,
    content: null,
  },
  {
    key: "data-visualization", 
    value: EXTERNAL_LINKS.IMETALAB_METAMAP, 
    label: "iMetaReport Demo", 
    icon: "pie-chart", //antd icon filled
    list: null,
    content: null
  },
  {
    key: "data-analysis", 
    value: EXTERNAL_LINKS.IMETALAB_SHINY, 
    label: "iMetaShiny", 
    icon: "box-plot", //antd icon filled
    list: null,
    content: null
  },
  {
    key: "account", 
    value: EXTERNAL_LINKS.IMETALAB_ACCOUNT, 
    label: "iMetaLab Account",
    icon: 'user',  //antd icon outlined
    list: null,
    content: null
  }
];